export default "__VITE_ASSET__CSeu6OHe__"